// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_4f720283bf--tooltip--y6_Qo","show-tooltip":"_4f720283bf--show-tooltip--V9eD3","content":"_4f720283bf--content--lwrIw","close":"_4f720283bf--close--YSEcZ"};